import { createStyles } from 'antd-style'

export default createStyles(() => {
  return {
    modalContent: {
      // height: 'calc(100vh - 100px)',
    },
  }
})
